/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_DocumentInputs */

const en_public_document = /** @type {(inputs: Public_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public`)
};

const id_public_document = /** @type {(inputs: Public_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publik`)
};

/** @type {(inputs: Public_DocumentInputs) => LocalizedString} */
const es_public_document = en_public_document;

/** @type {(inputs: Public_DocumentInputs) => LocalizedString} */
const fr_public_document = en_public_document;

/** @type {(inputs: Public_DocumentInputs) => LocalizedString} */
const de_public_document = en_public_document;

/** @type {(inputs: Public_DocumentInputs) => LocalizedString} */
const ja_public_document = en_public_document;

/** @type {(inputs: Public_DocumentInputs) => LocalizedString} */
const zh_public_document = en_public_document;

/** @type {(inputs: Public_DocumentInputs) => LocalizedString} */
const ar_public_document = en_public_document;

/** @type {(inputs: Public_DocumentInputs) => LocalizedString} */
const it_public_document = en_public_document;

/** @type {(inputs: Public_DocumentInputs) => LocalizedString} */
const ru_public_document = en_public_document;

/** @type {(inputs: Public_DocumentInputs) => LocalizedString} */
const pt_public_document = en_public_document;

/** @type {(inputs: Public_DocumentInputs) => LocalizedString} */
const ko_public_document = en_public_document;

/**
* | output |
* | --- |
* | "Public" |
*
* @param {Public_DocumentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const public_document = /** @type {((inputs?: Public_DocumentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_DocumentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_document(inputs)
	if (locale === "es") return es_public_document(inputs)
	if (locale === "fr") return fr_public_document(inputs)
	if (locale === "de") return de_public_document(inputs)
	if (locale === "ja") return ja_public_document(inputs)
	if (locale === "zh") return zh_public_document(inputs)
	if (locale === "ar") return ar_public_document(inputs)
	if (locale === "id") return id_public_document(inputs)
	if (locale === "it") return it_public_document(inputs)
	if (locale === "ru") return ru_public_document(inputs)
	if (locale === "pt") return pt_public_document(inputs)
	return ko_public_document(inputs)
});